import type { RouteLocationNormalized, RouteRecordRaw } from 'vue-router'
import { useAiEmployeeConsoleStore } from '@/store/modules/aiEmployeeConsole'
import { NEW_AI_EMPLOYEE_CONSOLE_PREFIX, useNewAiEmployeeConsoleStore } from '@/store/modules/newAiEmployeeConsole'

function Layout() {
  return import('@/layouts/index.vue')
}

const aiEmployeePermissions = [
  'crae:ai:setting:list',
  'crae:ai:setting:update',
  'crae:ai:task-record:list',
  'crae:ai:memory:list',
  'crae:ai:memory:update',
  'crae:ai:chat-record:list',
  'crae:ai:balance:list',
  'crae:ai:balance:recharge',
]

function resolveTabPresentation(route: RouteLocationNormalized) {
  const isNew = route.path === NEW_AI_EMPLOYEE_CONSOLE_PREFIX || route.path.startsWith(`${NEW_AI_EMPLOYEE_CONSOLE_PREFIX}/`)
  if (route.path === (isNew ? NEW_AI_EMPLOYEE_CONSOLE_PREFIX : '/crae-ai-employee')) {
    return { hidden: true }
  }
  const navigation = (isNew ? useNewAiEmployeeConsoleStore() : useAiEmployeeConsoleStore()).resolveNavigation(route.path)
  return navigation
    ? { title: navigation.title, icon: navigation.icon }
    : undefined
}

const routes = {
  path: '/crae-ai-employee',
  component: Layout,
  name: 'CraeAiEmployee',
  meta: {
    title: 'AI员工',
    icon: 'i-ant-design:usergroup-add-outlined',
    menuFlatten: true,
    breadcrumb: false,
    auth: aiEmployeePermissions,
  },
  children: [
    {
      path: ':pathMatch(.*)*',
      name: 'CraeAiEmployeeConsole',
      component: () => import('@/views/ai-employee-console/index.vue'),
      meta: {
        title: 'AI员工',
        icon: 'i-ant-design:usergroup-add-outlined',
        menuPath: '/crae-ai-employee',
        viewKey: 'routeName',
        tabPresentation: resolveTabPresentation,
        auth: aiEmployeePermissions,
      },
    },
  ],
} satisfies RouteRecordRaw

export default routes

export const newAiEmployeeRoutes: RouteRecordRaw = {
  ...routes,
  path: NEW_AI_EMPLOYEE_CONSOLE_PREFIX,
  name: 'NewcraeAiEmployee',
  meta: { ...routes.meta, title: '新AI员工' },
  children: [{
    ...routes.children![0],
    name: 'NewcraeAiEmployeeConsole',
    props: { newcrae: true },
    meta: {
      ...routes.children![0].meta,
      title: '新AI员工',
      menuPath: NEW_AI_EMPLOYEE_CONSOLE_PREFIX,
    },
  }],
}
